import { MenuItemProps } from '@mui/material/MenuItem';
import { OptionItem } from '../../cards/card.types';

export type EnhancedOptionItem = OptionItem | [OptionItem, Partial<MenuItemProps>];

export const getOptionItem = (option: EnhancedOptionItem): OptionItem => (
  Array.isArray(option) ? option[0] : option
);

export const getMenuItemProps = (option: EnhancedOptionItem): Partial<MenuItemProps> => (
  Array.isArray(option) ? option[1] : {}
);

export function divideOptionsIntoSections(options: EnhancedOptionItem[]): EnhancedOptionItem[][] {
  const sectionConfig = [
    [OptionItem.Edit, OptionItem.Duplicate, OptionItem.Rename,
      OptionItem.Delete, OptionItem.Regenerate, OptionItem.Test],
    [OptionItem.Export, OptionItem.Import],
    [OptionItem.Activity, OptionItem.Workflows, OptionItem.Reports],
    [OptionItem.Shared, OptionItem.Repeatables],
    [OptionItem.Deactivate],
  ] as const;

  const optionToSectionMap = new Map<OptionItem, number>();

  sectionConfig.forEach((sectionOptions, sectionIndex) => {
    sectionOptions.forEach((option) => {
      optionToSectionMap.set(option, sectionIndex);
    });
  });

  const sections = options.reduce<EnhancedOptionItem[][]>((acc, option) => {
    const optionItem = getOptionItem(option);
    const sectionIndex = optionToSectionMap.get(optionItem);

    if (sectionIndex !== undefined) {
      if (!acc[sectionIndex]) {
        acc[sectionIndex] = [];
      }
      acc[sectionIndex].push(option);
    }

    return acc;
  }, []);

  return sectionConfig.map((_, index) => sections[index] || []);
}
